import { getUrl, requests } from "../../globals/requests";
import {
  LOADING_GET_SAVINGS,
  GET_SAVINGS,
  SET_SAVING,
  LOADING_UPDATE_SAVING,
} from "../types";

export const setSaving = (payload) => {
  return {
    type: SET_SAVING,
    payload,
  };
};

export const getSavings = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: LOADING_GET_SAVINGS,
        payload: true,
      });
      const url = getUrl("savings");
      const response = await requests.getWithAuth(url);

      dispatch({
        type: GET_SAVINGS,
        payload: response.data,
      });

      dispatch({
        type: LOADING_GET_SAVINGS,
        payload: false,
      });
      return response.data;
    } catch (e) {
      dispatch({
        type: LOADING_GET_SAVINGS,
        payload: false,
      });
      throw e;
    }
  };
};
export const getSaving = (id) => {
  return async (dispatch) => {
    try {
      const url = `${getUrl("savings")}/${id}`;
      const response = await requests.getWithAuth(url);

      dispatch({
        type: SET_SAVING,
        payload: response.data,
      });

      return response.data;
    } catch (e) {
      throw e;
    }
  };
};

export const toggleSavingsLock = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: LOADING_UPDATE_SAVING,
        payload: true,
      });
      const url = `${getUrl("savings")}/${id}/lock`;
      const response = await requests.getWithAuth(url);

      dispatch({
        type: LOADING_UPDATE_SAVING,
        payload: false,
      });

      dispatch({
        type: SET_SAVING,
        payload: response.data,
      });

      return response.data;
    } catch (e) {
      dispatch({
        type: LOADING_UPDATE_SAVING,
        payload: false,
      });
      throw e;
    }
  };
};
